import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Icon, Select, MenuItem, IconButton,
} from '@material-ui/core';
import momentPropTypes from 'react-moment-proptypes';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
  },
};

const options = [
  { name: 'Tag', value: 'day' },
  { name: 'Woche', value: 'week' },
  { name: 'Monat', value: 'month' },
];

class DateRangeStepper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: options[0].value,
    };
  }

  addToDate = (value, unit) => {
    const { startDate, endDate, onDatesChanged } = this.props;

    onDatesChanged({
      startDate: startDate.add(value, unit).unix(),
      endDate: endDate.add(value, unit).unix(),
    });
  }

  handleChange = (e) => {
    this.setState({ selectedOption: e.target.value });
  }

  render() {
    const { selectedOption } = this.state;

    const optionItems = options.map(option => <MenuItem key={option.value} value={option.value}>{option.name}</MenuItem>);

    return (
      <div style={styles.container}>
        <IconButton
          onClick={() => this.addToDate(-1, selectedOption)}
        >
          <Icon>keyboard_arrow_left</Icon>
        </IconButton>
        <Select
          value={selectedOption}
          onChange={this.handleChange}
        >
          {optionItems}
        </Select>
        <IconButton
          onClick={() => this.addToDate(1, selectedOption)}
        >
          <Icon>keyboard_arrow_right</Icon>
        </IconButton>
      </div>
    );
  }
}

DateRangeStepper.propTypes = {
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
  onDatesChanged: PropTypes.func.isRequired,
};

DateRangeStepper.defaultProps = {
  startDate: null,
  endDate: null,
};

export default DateRangeStepper;
